
function getTextForChequingFeature({ intl, value, isDollars, isPercentage }) {
    // if isDollars or isPercentage, floatValue becomes a number or NaN
    const floatValue = isDollars || isPercentage
        ? parseFloat(value)
        : undefined;

    if (isDollars && !isNaN(floatValue)) {
        return intl.formatNumber(floatValue, { format: 'CAD2' });
    }

    if (isPercentage && !isNaN(floatValue)) {
        return intl.formatNumber(floatValue / 100, { format: 'percent2' });
    }

    // might just be some numeric value, like number of transactions (isDollars and isPercentage will both be false)
    const intValue = parseInt(value);
    if (!isNaN(intValue)) {
        return intl.formatNumber(intValue);
    }

    // not a number; let’s check on the string-based values we are expecting
    if (value === 'Free') {
        return intl.formatMessage({
            id: 'web-components.chequing.free',
            defaultMessage: 'Free',
        });
    }

    if (value === 'Unlimited') {
        return intl.formatMessage({
            id: 'web-components.chequing.unlimited',
            defaultMessage: 'Unlimited',
        });
    }

    // just some string
    return value;
}


export default getTextForChequingFeature;
